export default "__VITE_ASSET__e2112ae7__"